import { useState, useContext, useEffect, Fragment } from "react";
import { useNavigate } from "react-router-dom";
import { Divider, Grid } from "@mui/material";
import { EmptyWallet, LogoutCurve, User, UserTick } from "iconsax-react";
import { useTranslation } from "react-i18next";
import { LocaleContext } from "../../../routing/LangRouter";
import axiosInstance from "../../../api/axios";

//import utils
import { numberWithCommas } from "../../../utils/utility";

//import general components
import QuestionModal from "../question-modal/question-modal";
import BasePopover from "../base-popover/base-popover";

//import styles
import "./profile-widget.scss";

function ProfileWidget({ handleTokenExist }) {
    //general variables
    const navigate = useNavigate();
    const { locale } = useContext(LocaleContext);
    const { t } = useTranslation();
    const accessToken = localStorage.getItem("accessToken");
    const userInformation = JSON.parse(localStorage.getItem("userInformation"));

    //request to get user balance
    const [balance, setBalance] = useState(0);
    const getUserBalance = async () => {
        const response = await axiosInstance.get(`/api/v2/account/user/balance/`);
        setBalance(response?.data?.data?.balance || 0);
    };

    useEffect(() => {
        getUserBalance();
    }, []);

    //handle Popover
    const [anchorEl, setAnchorEl] = useState(null);
    const handleOpenPopover = event => {
        setAnchorEl(event.currentTarget);
    };
    const handleClosePopover = () => {
        setAnchorEl(null);
    };
    const isPopoverOpen = Boolean(anchorEl);
    const popoverId = isPopoverOpen ? "language-popover" : undefined;

    //navigate to url
    const handleNavigate = url => {
        navigate(`/${locale}/${url}`);
        handleClosePopover();
    };

    //logout user
    const [open, setOpen] = useState(false);
    const logout = () => {
        localStorage.clear();
        handleTokenExist(!!accessToken);
        navigate(`/${locale}`);
    };

    // render icons with consistent styling
    const renderIcon = icon => {
        const Icon = icon;
        return <Icon size="20" color="var(--teal-color-18)" variant="Outline" />;
    };

    return (
        <Grid className="profile-widget" container item xs="auto">
            <Grid
                className={`profile-widget__username ${isPopoverOpen ? "open" : ""}`}
                container
                item
                xs={12}
                columnGap={1}
                justifyContent="center"
                alignItems="center"
                onClick={handleOpenPopover}
            >
                {renderIcon(User)}
                <Grid className="profile-widget__name" container item xs={12} md="auto" justifyContent="center" display={{ xs: "none", md: "flex" }}>
                    <span className="profile-widget__title">
                        {userInformation?.registered_with_email ? userInformation?.email : userInformation?.username}
                    </span>
                </Grid>
            </Grid>
            <BasePopover
                id={popoverId}
                open={isPopoverOpen}
                anchorEl={anchorEl}
                handleClose={handleClosePopover}
                width="10%"
                vertical="bottom"
                horizontal={locale === "en" ? "left" : "right"}
                radius="0 0 0.5rem 0.5rem"
            >
                <Grid rowGap={1} container item xs={12}>
                    {[
                        { label: t("userAccount"), icon: UserTick, handleClick: () => handleNavigate("user-panel/user-account") },
                        {
                            label: t("credit"),
                            icon: EmptyWallet,
                            value: `${numberWithCommas?.(balance || 0)} ریال`,
                            handleClick: () => handleNavigate("user-panel/wallet"),
                        },
                        {
                            label: t("signout"),
                            icon: LogoutCurve,
                            handleClick: () => {
                                setOpen(true);
                                handleClosePopover();
                            },
                        },
                    ].map((item, index) => (
                        <Fragment key={index}>
                            <Grid container item xs={12} columnGap={1} justifyContent="center" alignItems="center" onClick={item.handleClick}>
                                {renderIcon(item.icon)}
                                <span className="profile-widget__item">{item.label}</span>
                                <span className="profile-widget__item" style={{ color: "green" }}>
                                    {item?.value}
                                </span>
                            </Grid>
                            {index < 2 && <Divider width="100%" />}
                        </Fragment>
                    ))}
                </Grid>
            </BasePopover>

            <QuestionModal open={open} setOpen={setOpen} question={t("areYouSure")} colorYes="blue-gray" colorNo="teal-18" handleClick={logout} />
        </Grid>
    );
}

export default ProfileWidget;
